// extracted by mini-css-extract-plugin
module.exports = {"filterContent":"_143uN","sliderWrapper":"qBxx8","currentPricesText":"_3Cx4v"};